import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import ModalWindow from '../../modal/Window';
import FormFragment from './Fragment';
import placeholders from '../../data/placeholders';
/**
 * A form window panel used to manage data
 * @extends {React.Component<import('./types').FormDialogProps>}
 */

var FormDialog =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormDialog, _React$Component);

  function FormDialog() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FormDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormDialog)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderWindow = function (formData, renderContent, renderFooter) {
      var _this$props = _this.props,
          windowProps = _this$props.windowProps,
          dataItemProps = _this$props.dataItemProps;
      var header = '';

      if (dataItemProps) {
        if (dataItemProps.id) {
          header = placeholders('Edit {type}', dataItemProps);
        } else {
          header = placeholders('Create {type}', dataItemProps, _this.props.defaultValue);
        }
      }

      return React.createElement(ModalWindow, Object.assign({
        onClose: _this.props.onCancel,
        overlay: true,
        renderContent: renderContent,
        renderFooter: renderFooter,
        renderArg: formData,
        header: header
      }, windowProps));
    };

    return _this;
  }

  _createClass(FormDialog, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          windowProps = _this$props2.windowProps,
          rest = _objectWithoutProperties(_this$props2, ["windowProps"]);

      return React.createElement(FormFragment, Object.assign({}, rest, {
        renderer: this.renderWindow
      }));
    }
  }]);

  return FormDialog;
}(React.Component);

FormDialog.defaultProps = {
  hideCancelButton: false,
  submitAlign: 'right',
  color: 'primary'
};
export default FormDialog;